/**
 * Enumeration of custom event names that are emitted by the components.
 */
export const BpEventType = {
  Error: "bp:error",
  ExternalLink: "bp:external_link",
  ScriptureLink: "bp:scripture_link",
} as const;

export type BpEventType = (typeof BpEventType)[keyof typeof BpEventType];

/**
 * Emit a custom `bp:error` event.
 *
 * @deprecated Use `events.error()` instead.
 */
export function emitError(detail: Record<string, unknown>) {
  emitEvent(BpEventType.Error, detail);
}

/**
 * Emit a custom event to the document to be handled by the host application.
 */
export function emitEvent(type: BpEventType, detail: Record<string, unknown>) {
  globalThis.document?.dispatchEvent(
    new CustomEvent(type, {
      detail,
    }),
  );
}

/**
 * Typed facade for emitting custom bp:* events.
 */
export const events = {
  error: (detail: Record<string, unknown>) =>
    emitEvent(BpEventType.Error, detail),
  requestLinkOpen: (href: string) =>
    emitEvent(BpEventType.ExternalLink, { href }),
  requestScriptureOpen: (reference: string) =>
    emitEvent(BpEventType.ScriptureLink, { reference }),
} as const;
